import React from "react";

import airplaneCoins from "../../../../../img/landing-page/quiz/airplane-coins.png";
import cloudCoins from "../../../../../img/landing-page/quiz/cloud-coins.png";

const LandingPageQuizResultBase = ({
	text,
	strongText,
	buttonText,
	buttonAction,
	icon
} = props) => {
	return (
		<div className="offers-landing-page-quiz-result-base">
			<img alt="" src={cloudCoins} />
			<div>
				<h2>Resultado</h2>
				<p>{text}</p>
				<p>
					<strong>{strongText}</strong>
				</p>
				<button onClick={step => buttonAction(1)} className="btn-green-md-s">
					{buttonText}
				</button>
			</div>
			<img src={airplaneCoins} alt="" />
		</div>
	);
};

export default LandingPageQuizResultBase;
